// components/ProtectedRoute.tsx
import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Login from './Login';
import OTPVerification from './OTPVerification';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { authState, isLoggedIn, isLoading, checkAuthStatus, logout, userEmail } = useAuth();

  useEffect(() => {
    // Check auth status on route access
    if (!isLoading && !checkAuthStatus()) {
      console.log('Protected route: Authentication check failed, logging out...');
      logout();
    }
  }, [isLoading, checkAuthStatus, logout]);

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #f5f5f5 0%, #e5e7eb 100%)'
      }}>
        <div style={{
          padding: '24px',
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '18px', fontWeight: 600, marginBottom: '8px', color: '#1f2937' }}>
            Checking authentication...
          </div>
          <div style={{ fontSize: '14px', color: '#64748b' }}>
            Please wait
          </div>
        </div>
      </div>
    );
  }

  // Show OTP form if needed
  if (authState === 'otp') {
    return <OTPVerification email={userEmail} />;
  }

  // Show login if not authenticated
  if (!isLoggedIn) {
    return <Login />;
  }

  // Render protected content if authenticated
  return <>{children}</>;
};

export default ProtectedRoute;